import { connect } from "react-redux"
import withImmutablePropsToJS from "with-immutable-props-to-js"

// components
import BulkActionsAlignment from "app/static/frontend/search-new/components/BulkActions/actions/BulkActionsAlignment"

// slectors
import { alignmentTypeSearchConnection } from "shared/stakeholder/selectors"

export default connect(alignmentTypeSearchConnection, null)(withImmutablePropsToJS(BulkActionsAlignment))
